import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import { Serialize } from '../../services/serializeFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  storeAulaPratica (aulasDatas) {
    let self = this

    self.disableButtons(true)

    var formAgenda = Serialize.withFormData('form_agendamento')

    formAgenda.delete('data-ini')
    formAgenda.delete('data-end')

    var count = 0
    for (var data of aulasDatas) {
      formAgenda.append('aula_' + count, data.data + ' ' + data.horario + '_' + data.dupla)
      count++
    }

    Vue.http.post(urlApi + '/agendamentos/aulapratica', formAgenda).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        router.push({ name: 'aulas-agendadas' })
      } else {
        self.launchToast('fa-times', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else if (response.status === 400) {
        self.launchToast('fa-check', response.data.dados)
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  dataErrada () {
    let self = this
    self.launchToast('fa-times', 'Ops! data inicial menor que data final!')
  },
  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  },
  getAlunos (callback) {
    Vue.http.get(urlApi + '/alunos/etapa/4').then((response) => {
      callback(response.data)
    })
  },
  getInstrutores (callback) {
    Vue.http.get(urlApi + '/instrutores').then((response) => {
      callback(response.data)
    })
  },
  getVeiculos (callback) {
    Vue.http.get(urlApi + '/veiculos').then((response) => {
      callback(response.data)
    })
  },
  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },
  getAulas (callback) {
    let self = this
    var dataInicial = document.getElementById('data-ini').value.replace(/-/g, '_')
    var dataFinal = document.getElementById('data-end').value.replace(/-/g, '_')
    var idInstrutor = document.getElementById('id_instrutor').value
    var error = false

    if (!dataInicial) {
      self.launchToast('fa-times', 'Selecione uma data inicial!')
      error = true
    }

    if (!dataFinal) {
      self.launchToast('fa-times', 'Selecione uma data final!')
      error = true
    }

    if (!idInstrutor) {
      self.launchToast('fa-times', 'Selecione um instrutor!')
      error = true
    }

    if (!document.getElementById('id_tipo').value) {
      self.launchToast('fa-times', 'Selecione um tipo!')
      error = true
    }

    if (error) {
      return
    }

    Vue.http.get(urlApi + '/agendamentos/aulas/instrutores/' + idInstrutor + '/' + dataInicial + '/' + dataFinal).then((response) => {
      callback(response)
    })
  },
  parse (str) {
    var args = [].slice.call(arguments, 1)
    var i = 0

    return str.replace(/%s/g, () => args[i++])
  },

  checkClass (classDatetime, aulasDatas) {
    var count = 0
    aulasDatas.forEach(function (aula) {
      if (aula.classDatetime.split(' ')[0] === classDatetime.split(' ')[0]) {
        ++count
      }
    })
    if (count > 2) {
      return true
    } else {
      return false
    }
  },

  getAulaAgendadaById: function (idAulaPratica, callback) {
    Vue.http.get(urlApi + '/aulas/praticas/agendada/' + idAulaPratica).then(function (response) {
      console.log(response)
      callback(response)
    })
  },

  getAulaRealizadaById: function (idAulaPratica, callback) {
    Vue.http.get(urlApi + '/aulas/praticas/realizada/' + idAulaPratica).then(function (response) {
      console.log(response)
      callback(response)
    })
  },

  updateFoto (id_foto_pratica, id_status) {
    Vue.http.get(urlApi + '/aulas/praticas/fotos/' + id_foto_pratica + '/' + id_status).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  updateFotos (fotos) {
    Vue.http.post(urlApi + '/aulas/praticas/fotos/todas', { 'fotos': fotos }).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  loadAvaliacoes (aula, callback) {
    Vue.http.get(`${urlApiV2}/aulas/praticas/feedback/avaliacoes-instrutor/${aula}`).then((response) => {
      callback(response.body)
    }).catch((error) => {
      callback(error)
    })
  },

  loadFeedback (aula, callback) {
    Vue.http.get(`${urlApiV2}/aulas/praticas/feedback/avaliacao-aula/${aula}?schema=`).then((response) => {
      callback(response.body)
    }).catch((error) => {
      callback(error)
    })
  },
}
